import ApiService from "../../../ApiService";

const ListService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/partner/list/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    deletePartner: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/partner/list/deletepartner", { id }, successCallback, failureCallback);
    },
    deletePartners: (selectedIds, successCallback, failureCallback) => {
        ApiService.post("/web/admin/partner/list/deletepartners", { selectedIds }, successCallback, failureCallback);
    },
    updatePartnerStatus: (id, status, successCallback, failureCallback) => {
        ApiService.post("/web/admin/partner/list/updatepartnerstatus", { id, status }, successCallback, failureCallback);
    },
    updateMultiPartnersStatus: (selectedIds, status, successCallback, failureCallback) => {
        ApiService.post("/web/admin/partner/list/updatemultipartnersstatus", { selectedIds, status }, successCallback, failureCallback);
    },
    disableTeacher: (userId, successCallback, failureCallback) => {
        ApiService.post("/web/admin/partner/list/disableTeacher", { userId }, successCallback, failureCallback);
    },
    activateTeacher: (userId, successCallback, failureCallback) => {
        ApiService.post("/web/admin/partner/list/activateTeacher", { userId }, successCallback, failureCallback);
    },
};

export default ListService;